import React from 'react';
import './JourneeType.css';

function JourneeType() {
  return (
    <div className="journee-type-container">
      <h1 className="journee-type-title fade-in-up">
        Ma Journée Type
      </h1>

      <p className="journee-type-intro fade-in-up">
        Dans le cadre de mon BTS SIO (option SISR) et de mon travail chez Quietec,
        voici un aperçu des grandes étapes qui rythment mon quotidien quand je vais travailler.
      </p>

      <div className="timeline fade-in-up">
        <div className="timeline-item">
          <div className="timeline-marker" />
          <div className="timeline-content">
            <h2>07:30 - Réveil / Préparation</h2>
            <p>
              Je me réveille, je me douche, je déjeune et me prépare pour ma journée de travaille
                chez Quietec. Avant de partir souvent je vérifie mes mails et les dernières actualités
            </p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-marker" />
          <div className="timeline-content">
            <h2>09:30 - Début de journée au bureau</h2>
            <p>
              Arrivée chez Quietec : avec tout les collègues on se retrouve pour un café et on discuter de la journée à venir souvent.
              J'allume et prépare mon poste, lance teamviewer et mes notes pour pouvoir gérer les appels des clients.
            </p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-marker" />
          <div className="timeline-content">
            <h2>11:00 - Courte pause</h2>
            <p>
                Une petite pause afin de pouvoir sortir et prendre l'air, discuter avec les collègues et se détendre un peu avant de reprendre le travail.
            </p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-marker" />
          <div className="timeline-content">
            <h2>11:10 - Reprise du travail</h2>
            <p>
              Généralement quand je n'ai pas de poste clients à préparer on me confie des travaux d'apprentissage, ça peut aller de la mise en fonction
              d'un poste de récupération afin d'en faire un serveur afin de me faire la main sur les différentes technologies, au diagnostique d'un poste qui ne fonctionne
              plus et des solutions envisagées ainsi que leur application si elles sont réalisables. Mon responsable compte sur le fait que je fasses des erreurs afin 
              de ne plus les reproduires une fois que ces situations auront lieu pour de vrai avec des clients.
            </p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-marker" />
          <div className="timeline-content">
            <h2>12:00 - Pause déjeuner</h2>
            <p>
              J'apporte ma nourriture alors je mange au bureau dans la salle de pause, 
              je sors prendre l'air, discute avec les collègues et je me détends afin de reprendre l'après-midi en forme.
            </p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-marker" />
          <div className="timeline-content">
            <h2>14:00 - Reprise du travail</h2>
            <p>
              Je reprends le travail, je continue les tâches en cours ou je commence de nouveaux projets et je réponds aux appels des clients. 
              Quand un client appelle pour un problème que je penses être en mesure de résoudre, je demande à prendre à la main sur son poste et j'interviens à distance.
              Quand le client demande un collègue en particulier ou que le problème est trop complexe pour moi, je transfère l'appel à un collègue plus expérimenté ou prends notre
              et informe le client qu'on le rappellera dès que possible.
            </p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-marker" />
          <div className="timeline-content">
            <h2>18:00 - Fin de journée</h2>
            <p>
              Avant de partir, je me fais un dernier point rapide sur l'avancement
              de mes projets. Je vérifie rapidement la veille technologique sur ITConnect puis rentre chez moi.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JourneeType;
